// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-level tweaks */
.App {
    min-height: 100vh;
    background: var(--moss);
    position: relative;
}

/* Strict scroll isolation for the book inner scroller */
.book-scroll {
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    will-change: scroll-position;
}
.book-scroll::-webkit-scrollbar { width: 0; height: 0; display: none; }
.no-scrollbar { scrollbar-width: none; }
.no-scrollbar::-webkit-scrollbar { display: none; }

/* Hardware acceleration hints for transformed motion elements */
.folio-stage,
.folio-shadow,
[data-testid="closed-book"],
[data-testid="folio-book"] {
    transform: translateZ(0);
    backface-visibility: hidden;
}

/* Mobile scroll perf — pause heavy animations during scroll on small screens */
@media (max-width: 767px) {
    body { -webkit-tap-highlight-color: transparent; }
    .folio-stage { contain: layout paint; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,wDAAwD;AACxD;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;IACrB,4BAA4B;AAChC;AACA,kCAAkC,QAAQ,EAAE,SAAS,EAAE,aAAa,EAAE;AACtE,gBAAgB,qBAAqB,EAAE;AACvC,mCAAmC,aAAa,EAAE;;AAElD,gEAAgE;AAChE;;;;IAII,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA,+EAA+E;AAC/E;IACI,OAAO,wCAAwC,EAAE;IACjD,eAAe,qBAAqB,EAAE;AAC1C","sourcesContent":["/* App-level tweaks */\n.App {\n    min-height: 100vh;\n    background: var(--moss);\n    position: relative;\n}\n\n/* Strict scroll isolation for the book inner scroller */\n.book-scroll {\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    will-change: scroll-position;\n}\n.book-scroll::-webkit-scrollbar { width: 0; height: 0; display: none; }\n.no-scrollbar { scrollbar-width: none; }\n.no-scrollbar::-webkit-scrollbar { display: none; }\n\n/* Hardware acceleration hints for transformed motion elements */\n.folio-stage,\n.folio-shadow,\n[data-testid=\"closed-book\"],\n[data-testid=\"folio-book\"] {\n    transform: translateZ(0);\n    backface-visibility: hidden;\n}\n\n/* Mobile scroll perf — pause heavy animations during scroll on small screens */\n@media (max-width: 767px) {\n    body { -webkit-tap-highlight-color: transparent; }\n    .folio-stage { contain: layout paint; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
